export default "/static/d86bb38f8957f569.png"